/** Product mark: « Cu » on a copper tile (also the favicon / app icon). */
export function BrandMark({ className = 'size-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 36 36" className={className} aria-hidden>
      <rect width="36" height="36" rx="10" fill="#a65a2a" />
      <text
        x="18"
        y="23.5"
        textAnchor="middle"
        fontFamily="Inter Variable, Inter, system-ui, sans-serif"
        fontSize="15"
        fontWeight="800"
        fill="#ffffff"
      >
        Cu
      </text>
    </svg>
  );
}
